import { render } from "./HelpIndex.vue?vue&type=template&id=b18a63fa"
import script from "./HelpIndex.vue?vue&type=script&lang=js"
export * from "./HelpIndex.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__